(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      const closeButton = this.querySelector('.announcement__close');
      const ad = window.sessionStorage.getItem('announcementDismissed');

      if (!ad) {
        this.classList.remove('hide');
      }

      if (closeButton) {
        closeButton.addEventListener('click', this.hideAnnouncement.bind(this));
      }
    }

    hideAnnouncement() {
      window.sessionStorage.setItem('announcementDismissed', true);
      this.classList.add('announcement-bar--hide');

      setTimeout(() => {
        this.style.display = 'none';
      }, 300);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  window.onload = () => {
    class SignupBanner extends HTMLElement {
      constructor() {
        super();

        this.signupForm = this.querySelector('.newsletter-form');

        if (this.signupForm) {
          this.submitButton = this.signupForm.querySelector('button[type="submit"]');

          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }

          clearInputErrors(this.signupForm);

          this.signupForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      handleSubmit(evt) {
        const formIsValid = validateForm(this.signupForm);

        if (formIsValid) {
          if (this.submitButton) {
            this.submitButton.classList.add('btn--loading');
          }
        } else {
          evt.preventDefault();
        }
      }
    }

    customElements.define('signup-banner', SignupBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-linked-menu"]) return;
  try {
    
  class FaqLinkedMenu extends HTMLElement {
    constructor() {
      super();
      this.faqLinkedMenuContent = this.querySelector('.faq-linked-menu-content');
      this.accordionComponent = document.querySelectorAll('.faq-item');
      const faqlinkedItems = [];

      this.accordionComponent.forEach((elm, i) => {
        if (i != 0) {
          elm.classList.add('hide');
        }

        const faqLinkedMenuSection = elm.querySelector('[data-menu-info="faq-linked-menu"]');

        if (faqLinkedMenuSection) {
          const newMenuItem = document.createElement('li');
          newMenuItem.dataset.linkType = elm.dataset.sectionType;
          newMenuItem.innerHTML = faqLinkedMenuSection.innerHTML;

          if (i === 0) {
            newMenuItem.classList.add('active');
          }

          this.faqLinkedMenuContent.appendChild(newMenuItem);

          newMenuItem.addEventListener('click', this.handleClick.bind(this));
        }

        faqLinkedMenuSection.classList.add('hide');
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const contentId = target.dataset.linkType;

      const activeElement = document.querySelector(`[data-section-type=${contentId}]`);
      const activeHeaderItem = this.faqLinkedMenuContent.querySelector('li.active');

      if (activeHeaderItem !== target) {
        activeHeaderItem.classList.remove('active');
        target.classList.add('active');
      }

      this.accordionComponent.forEach((elm) => {
        if (!elm.classList.contains('hide')) {
          elm.classList.add('collapsible-content--hide');
          setTimeout(function () {
            elm.classList.add('hide');
          }, 200);
        }
      });

      setTimeout(function () {
        activeElement.classList.remove('hide');
        activeElement.classList.remove('collapsible-content--hide');
      }, 200);
    }
  }

  customElements.define('faq-linked-menu', FaqLinkedMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.background = this.getAttribute('data-background');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.headerHeight = this.header.offsetHeight;
      this.headerWrap = this.header.querySelector('.header-wrapper');
      this.isFrosted = this.headerWrap.dataset.frosted;
      this.isSticky = this.headerWrap.dataset.sticky;
      this.menuInline = this.header.querySelector('.list-menu--inline');
      this.activeMenuItem = this.header.querySelector('.header__active-menu-item');
      this.listMenuItems = this.header.querySelectorAll('.header__inline-menu .list-menu__item-list');

      this.openingMenu = false;
      this.closingMenu = false;
      this.isFadeOutTransition = false;
      this.listMenuItems.forEach((summary) => summary.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
      this.listMenuItems.forEach((summary) => summary.addEventListener('mouseleave', this.handleMouseleave.bind(this)));
      this.listMenuItems.forEach((summary) => summary.addEventListener('click', this.handleClick.bind(this)));

      if (this.isSticky) {
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      const searchHomeField = document.getElementById('search-home-field');
      let headerHeight = Math.round(this.header.clientHeight);
      if (searchHomeField) {
        headerHeight = headerHeight + Math.round(searchHomeField.clientHeight);
        if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
          searchHomeField.classList.add('search-home--transparent');
        }
      }
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      let prevHeight = 0;
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.contentBoxSize) {
            const height = entry.contentBoxSize?.[0].blockSize;
            if (typeof height === 'number' && height !== prevHeight) {
              prevHeight = height;
              let headerHeight = Math.round(this.header.clientHeight);
              if (searchHomeField) {
                headerHeight = headerHeight + Math.round(searchHomeField.clientHeight);
              }
              document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }
          }
        }
      });

      resizeObserver.observe(this.header);
      this.setupTransparency();
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:unload', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:reorder', this.setupTransparency.bind(this));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', this.background, 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', this.background, 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        this.background,
        'animate'
      );
    }

    handleClick(event) {
      const summaryElm = event.target;
      const menuItem = summaryElm.closest('.list-menu__item-list');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      this.header.classList.add(this.background, 'is-filled');
      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseEnter(event) {
      const menuItem = event.target;
      const menuItemSpan = menuItem.querySelector('.header__menu-item');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });
      menuItemSpan.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.closingMenu && detailsElement.getAttribute('open') && !this.isFadeOutTransition) {
        window.clearTimeout(this.timeoutClose);
        this.closingMenu = false;
      }

      if (detailsElement.getAttribute('open') && !this.isFadeOutTransition) return;

      window.clearTimeout(this.timeoutOpen);
      this.openingMenu = true;

      this.timeoutOpen = setTimeout(() => {
        this.openingMenu = false;
        this.openSubMenu(detailsElement);
      }, 300);
    }

    openSubMenu(detailsElement) {
      detailsElement.setAttribute('open', true);
      if (this.isFrosted) this.headerWrap.classList.remove('frosted-header-glass');
      this.header.classList.add(this.background, 'is-filled');
      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseleave(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });

      if (this.activeMenuItem) this.activeMenuItem.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.openingMenu && !detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutOpen);
        this.openingMenu = false;
      }

      if (!detailsElement.getAttribute('open')) return;

      this.closingMenu = true;
      this.timeoutClose = setTimeout(() => {
        this.closingMenu = false;
        this.closeSubMenu(detailsElement);
      }, 300);
    }

    closeSubMenu(detailsElement) {
      if (this.isFrosted) this.headerWrap.classList.add('frosted-header-glass');
      this.header.classList.remove('is-filled');
      if (!this.header.classList.contains('animate')) {
        this.header.classList.remove(this.background);
      }

      detailsElement.classList.remove('sub-menu-opening');
      this.isFadeOutTransition = true;

      detailsElement.addEventListener(
        'transitionend',
        () => {
          detailsElement.removeAttribute('open');
          this.isFadeOutTransition = false;
        },
        { once: true }
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        // this.searchModal.close(false);
      }
    }

    setupTransparency() {
      if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
        this.classList.add(this.background);
        this.setAttribute('data-transparency', true);
      } else {
        if (this.isSticky) {
          this.classList.remove(this.background);
        }
        this.removeAttribute('data-transparency');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"]) return;
  try {
    
  class newsletterForm extends HTMLElement {
    constructor() {
      super();
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      const sectionId = this.dataset.sectionId;
      const contactNewsletter = this.querySelector(`#Contact_${sectionId}`);
      const inputEmailGroup = contactNewsletter.querySelector('.input-group');
      const inputEmailNewsletter = contactNewsletter.querySelector('input[type="email"]');
      const errorMessage = contactNewsletter.querySelector(`#Newsletter-error--${sectionId}`);
      const errorMessageText = errorMessage.querySelector('.input-error-message__text');
      const iconError = contactNewsletter.querySelector('.field-wrapper__icon-error');
      const existingEmailMsg = contactNewsletter.querySelector('.newsletter-email-exist');
      const urlUserCame = document.referrer ? new URL(document.referrer) : null;

      inputEmailNewsletter.addEventListener('keyup', function (e) {
        if (e.code === 'Enter') return;
        inputEmailGroup.classList.remove('input-group--error');
        inputEmailNewsletter.classList.remove('input--error');
        errorMessage.classList.add('hide');
        iconError.classList.add('hide');
        if (existingEmailMsg) existingEmailMsg.classList.add('hide');
      });

      if (existingEmailMsg && searchParams.has('form_type') && inputEmailNewsletter.value) {
        existingEmailMsg.classList.remove('hide');
      }

      if ( urlUserCame && urlUserCame.pathname === '/challenge' ) {
        document.querySelector(`#Contact_${sectionId}`).scrollIntoView();
      }

      contactNewsletter.addEventListener('submit', (event) => {
        const email = inputEmailNewsletter.value;

        if (!this.validateEmail(email)) {
          event.preventDefault();
          var erroMessage = '';

          if (email === '') {
            erroMessage = window.loginStrings.errorEmailRequired;
          } else {
            erroMessage = window.loginStrings.errorEmailInvalid;
          }

          inputEmailGroup.classList.add('input-group--error');
          inputEmailNewsletter.classList.add('input--error');
          inputEmailNewsletter.setAttribute('aria_invalid', 'true');
          inputEmailNewsletter.setAttribute('aria_describedby', `Newsletter-error--${sectionId}`);
          inputEmailNewsletter.setAttribute('data_form_status', true);

          if (errorMessageText) errorMessageText.textContent = erroMessage;
          errorMessage.classList.remove('hide');
          iconError.classList.remove('hide');
          inputEmailNewsletter.focus();
        }

        return false;
      });
    }

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  customElements.define('newsletter-form', newsletterForm);

  } catch(e) { console.error(e); }
})();
})();
